import { Col, Row } from 'antd';
import ListItem from '@/components/LoadingDataDisplay/ListItem';
import Filters from './Filters';

const Loading = () => {
    return (
        <Row gutter={[20, 20]} className="loading-employee">
            <Col xs={24}>
                <Filters />
            </Col>
            <Col xs={24}>
                <ListItem className="loading-table" />
            </Col>
        </Row>
    );
};

export default Loading;
